import { render } from "./SeHelpTaxFormExamples.vue?vue&type=template&id=3891acae"
import script from "./SeHelpTaxFormExamples.vue?vue&type=script&lang=js"
export * from "./SeHelpTaxFormExamples.vue?vue&type=script&lang=js"

import "./SeHelpTaxFormExamples.vue?vue&type=style&index=0&id=3891acae&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__